import React from 'react'
import { IconProps } from './icons.types'

export const StarV2: React.FC<IconProps> = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3301 11.9573L15.3881 18.2913L12.0199 15.8442M7.94204 8.04268L10.0001 1.70866L11.2866 5.66822M18.718 8.04269L4.61197 18.2913L6.67001 11.9573L1.28198 8.04269H18.718Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
